// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Replace with your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCxl1qOwmsusg-6JuOR_gWReWrUyGsyoDs",
    authDomain: "pcr4v3-ebda1.firebaseapp.com",
    projectId: "pcr4v3-ebda1",
    storageBucket: "pcr4v3-ebda1.firebasestorage.app",
    messagingSenderId: "782614411593",
    appId: "1:782614411593:web:4fad8af3669fff64800298"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, db, auth };